import React from "react";
import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import { VMS_COLORS } from "../constants/theme";

const VmsPageCard = ({ title, description, children }) => (
  <Box
    bg={VMS_COLORS.cardBg}
    border="1px solid"
    borderColor={VMS_COLORS.border}
    borderRadius="18px"
    p={6}
    boxShadow="0 14px 35px rgba(16,24,40,0.08)"
  >
    <VStack align="stretch" spacing={4}>
      <Box>
        {title ? (
          <>
            <Heading size="md" color="gray.800">
              {title}
            </Heading>
            {description ? (
              <Text mt={1} color={VMS_COLORS.textMuted} fontSize="sm">
                {description}
              </Text>
            ) : null}
          </>
        ) : null}
      </Box>
      {children}
    </VStack>
  </Box>
);

export default VmsPageCard;
